/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'organization-status-misuse': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 1c-4.9 0-9 4.1-9 9s4.1 9 9 9 9-4 9-9-4-9-9-9zm3.5 13.5L10 11l-3.5 3.5-1-1L9 10 5.5 6.5l1-1L10 9l3.5-3.5 1 1L11 10l3.5 3.5-1 1z"/>'
  }
})
